import {
  init,
  setUser,
  captureException,
  browserTracingIntegration,
  ErrorBoundary,
  getCurrentScope,
} from '@sentry/react';
import { env } from '../../env.js';

export function initSentry() {
  if (!env.VITE_SENTRY_DSN) return;
  init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT ?? 'production',
    release: env.VITE_APP_VERSION,
    tracesSampleRate: 0.1,
    integrations: [
      browserTracingIntegration(),
    ],
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
        delete event.request.headers['authorization'];
      }
      return event;
    },
  });
}

export function setSentryUser(subject: { id: string; agentId: string } | null) {
  if (!env.VITE_SENTRY_DSN) return;
  if (!subject) {
    setUser(null);
    return;
  }
  setUser({ id: subject.id, segment: subject.agentId });
}

export const SentryErrorBoundary = ErrorBoundary;

export const Sentry = {
  captureException,
  setUser,
  getCurrentScope,
};
